<template>
    <!-- 弹框资金使用申请 -->
    <div>
        <el-dialog v-dialogDrag title="发票申请" width="95%" :show-close="true"
            :close-on-click-modal="false" :visible.sync="dialogFormVisible" :before-close="beforeclose">
            <el-form :model="form" ref="form" :rules="rules" :inline="true" class="demo-form-inline" label-width="90px" size="mini">
                <el-form-item label="单据编号">
                    <el-input :disabled="true" clearable v-model.trim="bh" autocomplete="off"></el-input>
                    <!-- <el-input :disabled="editCode === true ? false: true" clearable v-model.trim="bh" autocomplete="off"></el-input> -->
                </el-form-item>
                <el-form-item required label="往来单位" prop="company">
                    <!-- <el-select :disabled="((form.checkStatus === 0 || form.checkStatus === 3 ||  editCode === true) && detailData.length === 0) ?  false: true"  -->
                    <el-select v-if="editCode" :disabled=" editCode === true ?  false: true" 
                    @change="selectCompany" filterable v-model="form.company" placeholder="请选择往来单位">
                        <el-option v-for="item in customOption" :key="item.id" :label="item.name"
                            :value="{ value: item.id, label: item.name,invoiceInfo: item.invoiceInfo }">
                        </el-option>
                    </el-select>
                    <el-popover v-else placement="bottom" title="tip"  width="300" trigger="hover"
                        content="can't change company, but you can delete this bill and create a new one">
                        <el-input slot="reference" disabled v-model="form.company"></el-input>
                    </el-popover>
                    <!-- <el-input v-model.trim="form.company" autocomplete="off"></el-input> -->
                </el-form-item>
                <el-form-item label="金额" prop="amount">
                    <el-input :disabled="editCode === true ? false: true" clearable v-model.number="form.amount" autocomplete="off"></el-input>
                </el-form-item>
                
                <el-form-item  label="发票号" prop="voucherNo">
                    <el-input disabled clearable v-model="form.voucherNo" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item required label="币制" prop="currency">
                    <el-select :disabled="(form.checkStatus === 0 || form.checkStatus === 3 || editCode === true )? false: true" 
                    filterable v-model="form.currency" placeholder="请选择币制">
                        <el-option v-for="item in typeOption" :key="item.id" :label="item.value"
                            :value="item.value">
                        </el-option>
                    </el-select>
                    <!-- <el-input v-model.trim="form.currency" autocomplete="off"></el-input> -->
                </el-form-item>
                <el-form-item label="备注" prop="note">
                    <el-input :disabled="(form.checkStatus === 0 || form.checkStatus === 3 || editCode === true) ? false: true" 
                    clearable v-model="form.note" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="开票信息" prop="invoiceInfo">
                    <el-input  type="textarea" :disabled="(form.checkStatus === 0 || form.checkStatus === 3 || editCode === true)? false: true" 
                    clearable v-model="form.invoiceInfo" autocomplete="off"></el-input>
                </el-form-item>
                <!-- <el-form-item v-if="false" required label="银行账号" prop="bank">
                    <el-select :disabled="form.checkStatus === 0 || form.checkStatus === 3 ? false: true" filterable v-model.trim="form.bank" placeholder="请选择银行帐号" @change="selectBank">
                        <el-option v-for="item in bankOption" :key="item.id" :label="item.bankName"
                            :value="{ value: item.accountNum, label: item.bankName }">
                            <span style="float: left">{{ item.bankName }}</span>
                            <span style="float: right; color: #8492a6; font-size: 13px">{{ item.accountNum }}</span>
                        </el-option>
                    </el-select>
                </el-form-item> -->
                <el-form-item label=" " v-if="form.checkStatus === 0 || form.checkStatus === 3 || editCode === true">
                    <el-button  size="mini" type="success" plain @click="saveHeader('form')">保存单据</el-button>
                </el-form-item>
                 <el-form-item label=" " >
                    <el-button  size="mini" type="primary" plain @click="refreshHeader()">刷新附件列表</el-button>
                </el-form-item>
                <el-form-item label="上传附件">
                    <el-upload class="upload-demo" :action="saveOneAttachmentURL" :on-remove="handleRemove" :on-change="handleChange"
                    multiple :file-list="fileList" :auto-upload="false">
                    <el-button size="mini" type="primary">点击选择文件</el-button>
                    </el-upload>
                </el-form-item>
                <!-- <el-form-item label="附件列表" v-if="uploadFilesList.length>0">
                    <div class="upload-list">
                        <span v-for="item in uploadFilesList" :key="item.id">
                            <el-link type="primary" class="list-margin" @click="downloadFile(item)">{{ item.annexName }}</el-link>
                        </span>
                    </div>
                </el-form-item> -->
            </el-form>
            <div class="upload_box">
                <div class="upload_text">附件列表</div>
                <div class="upload-list"  v-if="uploadFilesList.length>0">
                    <span v-for="item in uploadFilesList" :key="item.id">
                        <el-link type="primary" class="list-margin" @click="downloadFile(item)">{{ item.annexName }}</el-link>
                    </span>
                </div>
            </div>
            <!-- <div slot="footer" class="dialog-footer">
                <!-- <el-button >取 消</el-button>
                <el-button type="primary" >确 定</el-button> -->
            <!-- </div>  -->
            <!-- 明细表格展示 -->
            <div >
                <el-table height="280px" :data="detailData" show-summary :summary-method="getSummaries"
                    border ref="detailData" style="width: 100%;margin-top: -0.5vh; ">
                    <el-table-column label="序号" type="index" width="60" align="center">
                    </el-table-column>
                    <el-table-column prop="blNo" label="提单号" align="center"> </el-table-column>
                    <el-table-column prop="subNo" label="分单号" align="center"> </el-table-column>
                    <el-table-column prop="containerNo" label="箱号" align="center"></el-table-column>
                    <el-table-column prop="feeName" label="费用名称" align="center">
                    </el-table-column>
                    <el-table-column prop="amount" label="结算金额" align="center">
                        <template slot-scope="scope">
                            <span v-format="'#,##0.00'">{{ scope.row.amount }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="createMan" label="创建人" align="center">
                    </el-table-column>
                    <el-table-column prop="createTime" label="创建时间" align="center">
                    </el-table-column>
                    <el-table-column prop="note" label="备注" align="center">
                    </el-table-column>
                    <el-table-column label="操作" width="auto" align="center" v-if="form.checkStatus === 0 || form.checkStatus === 3 || editCode === true">
                        <template slot-scope="scope">
                            <el-button plain size="mini" icon="el-icon-delete" type="danger"
                                @click="deleteRowDetail(scope.row)">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <el-divider content-position="center" >查询费用</el-divider>

            <!-- 查询并修改明细 -->
            <div v-if="form.checkStatus === 0 || form.checkStatus === 3 || editCode === true">
                <el-form :model="expenditList" ref="expenditList" size="mini"
                    style=" margin-top: 3px; display: flex; justify-content: space-around;" label-width="118px">
                    <div>
                        <el-form-item label="开始时间" prop="startDate">
                            <el-date-picker style="width: 100%;" clearable size="small" v-model="expenditList.startDate"
                                type="date" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择开始时间"
                                :picker-options="startNoTime">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item label="结束时间" prop="endDate">
                            <el-date-picker style="width: 100%;" clearable size="small" v-model="expenditList.endDate"
                                type="date" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择结束时间"
                                :picker-options="endNoTime">
                            </el-date-picker>
                        </el-form-item>
                    </div>
                    <div>
                        <el-form-item label="提单号" prop="blNo">
                            <el-input type="textarea" clearable v-model="expenditList.blNo" autocomplete="off"></el-input>
                        </el-form-item>
                        <el-form-item label="费用名称" prop="feeName">
                            <el-select filterable clearable v-model="expenditList.feeName" placeholder="请选择费用名称">
                                <el-option v-for="item in feeOption" :key="item.id" :label="item.feeName"
                                    :value="item.feeName">
                                </el-option>
                            </el-select>
                        </el-form-item>

                    </div>
                    <div>
                        <el-form-item label="往来单位" prop="custName">
                            <el-input disabled v-model="expenditList.custName" autocomplete="off"></el-input>
                        </el-form-item>
                        <el-form-item label="币制" prop="currency">
                            <el-input disabled clearable v-model="expenditList.currency"
                                autocomplete="off"></el-input>
                        </el-form-item>
                    </div>
                    <div>
                        <el-button  type="primary" size="mini"
                            @click="expendRow">查询应收明细</el-button>
                        <el-button size="mini" @click="allSaveList" type="success" style="">添加明细</el-button>
                    </div>


                </el-form>
                <div>
                    <!-- <el-button size="small" @click="addRow">编辑全部</el-button> -->
                    <el-table height="32vh" :data="detailtableData" 
                        @selection-change="handleSelectionChange" highlight-current-rowF :empty-text="'暂无数据'"
                        size="mini" style="width: 100%; margin-top: -0.6vh;">
                        <el-table-column type="selection" width="35" align="center">
                        </el-table-column>
                        <el-table-column prop="blNo" label="提单号" width="auto" align="center">
                            <template slot-scope="scope">
                                <el-input clearable disabled v-model="scope.row.blNo" placeholder="请输入提单号"
                                    v-if="scope.row.editing"></el-input>
                                <span v-show="!scope.row.editing">{{ scope.row.blNo }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="subNo" label="分单号" width="auto" align="center"> </el-table-column>
                        <el-table-column prop="containerNo" label="箱号" width="auto" align="center"> </el-table-column>
                        <el-table-column prop="company" label="客户名称" width="auto" align="center">
                            <template slot-scope="scope">
                                <el-input disabled clearable v-model="scope.row.company" placeholder="请输入客户名称"
                                    v-if="scope.row.editing"></el-input>
                                <span v-show="!scope.row.editing">{{ scope.row.company }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="feeName" label="费用名称" width="auto" align="center">
                            <template slot-scope="scope">
                                <el-select disabled filterable clearable v-model="scope.row.feeName"
                                    placeholder="请选择费用名称" v-show="scope.row.editing">
                                    <el-option v-for="item in feeOption" :key="item.id" :label="item.feeName"
                                        :value="item.feeName">
                                    </el-option>
                                </el-select>
                                <span v-show="!scope.row.editing">{{ scope.row.feeName }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="remain" label="结算金额" width="auto" align="center">
                            <template slot-scope="scope">
                                <el-input @input="limitInput(scope.row)" style="width: 100%;"
                                    onkeyup="value=value.match(/\d+\.?\d{0,2}/,'')" clearable v-model="scope.row.remain"
                                    placeholder="请输入应付" ></el-input>
                                <!-- <span>{{ scope.row.remainCopy }}</span> -->
                            </template>
                        </el-table-column>
                        <el-table-column prop="finance" label="已付金额" width="auto" align="center">
                            <template slot-scope="scope">
                                <el-input disabled clearable v-model.number="scope.row.finance" placeholder="请输入余额"
                                    v-if="scope.row.editing"></el-input>
                                <span v-show="!scope.row.editing" v-format="'#,##0.00'">{{ scope.row.finance }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="totalWt" label="应付总金额" width="auto" align="center">
                            <template slot-scope="scope">
                                <el-input disabled clearable v-model="scope.row.totalWt" placeholder="请输入总金额"
                                    v-if="scope.row.editing"></el-input>
                                <span v-show="!scope.row.editing" v-format="'#,##0.00'">{{ scope.row.totalWt }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="currency" label="币制" width="auto" align="center">
                            <template slot-scope="scope">
                                <el-input disabled clearable v-model="scope.row.currency" placeholder="请输入币制"
                                    v-if="scope.row.editing"></el-input>
                                <span v-show="!scope.row.editing">{{ scope.row.currency }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="createTime" label="创建时间" width="auto" align="center">
                            <template slot-scope="scope">
                                <el-input disabled clearable v-model="scope.row.createTime" placeholder="请输入创建时间"
                                    v-if="scope.row.editing"></el-input>
                                <span v-show="!scope.row.editing">{{ scope.row.createTime }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="note" label="备注" width="auto" align="center">
                            <template slot-scope="scope">
                                <el-input style="width: 100%;" clearable v-model="scope.row.note"
                                    placeholder="请输入备注"></el-input>
                                <!-- <span v-show="!scope.row.editing">{{ scope.row.note }}</span> -->
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" width="100" align="center">
                            <template slot-scope="scope">
                                <el-button v-if="!scope.row.editing" @click="deleteRow(scope.row)" type="text"
                                    size="mini" style="margin-left: 10px;padding: 3px;">删除</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
        </el-dialog>
        
    </div>
</template>

<script>
import req from '@/utils/index.js'
import url from '@/config/url1.js'
import url1 from '@/config/url2.js'
export default {
    name: 'addFund',
    props: ['busId',],
    data() {
        return {
            editCode:false,// 添加时除发票号外都可填写
            detailSelect: [],
            isbig: false,
            remain: '',//结算金额显示余额
            headerId: '',//表头id
            detailtableData: [],//应付费用明细列表
            expenditList: {
                feeName: '',
                blNo: '',
                blNos:[],
                custName: '',
                currency: '',
                startDate: '',
                endDate: '',
                feeType: 1
            },//应付费用明细列表查询
            detailData: [],//应付明细数据
            feeOption: [],//费用类型数据
            bankOption: [],
            typeOption: [],
            customOption: [],
            originalBankOption: [], // 用于存储初始的 bankOption，以便对比
            dialogFormVisible: false,
            form: {
                company: '',
                voucherNo: '',
                // bank: '',
                // bankAccount: '',
                note: '',//备注
                amount: '',
                currency: '',
                id: '',
                invoiceInfo:'',
            },
            companyId: '',
            bh: '',
            uploadFilesList: [], // 已上传文件列表
            saveOneAttachmentURL:url1.saveOneAttachment, // 上传文件url
            fileList:[], // 上传文件列表
            rules: {
                company: [
                    { required: true, message: '请选择往来单位', trigger: 'change' }
                ],
                // voucherNo: [
                //     { required: true, message: '请填写发票号', trigger: 'blur' }
                // ],
                // bank: [
                //     { required: true, message: '请选择银行帐户', trigger: 'change' }
                // ],
                // bankAccount: [
                //     { required: true, message: '请选择活动资源', trigger: 'change' }
                // ],
                // amount: [
                //     { required: true, message: '请填写金额', trigger: 'blur' }
                // ],
                invoiceInfo:[
                    { required: true, message: '请填写开票信息', trigger: 'blur' }
                ],
                currency: [
                    { required: true, message: '请选择币制', trigger: 'change' }
                ],
            },
            startNoTime: {
                disabledDate(date) {
                    // 可选当天以及当天之前的日期
                    return date.getTime() > Date.now()
                }
            },
            // 结束时间限制范围
            endNoTime: {
                disabledDate(date) {
                    // 可选当天以及当天之前的日期
                    return date.getTime() > Date.now()
                }
            },
            isInitialLoad: true,
        }
    },
    updated() {
        //异步更新表格内数据
        this.$nextTick(() => {
            if (this.$refs.detailData) {
                this.$refs.detailData.doLayout();
            }
        });


    },
    watch: {
        "expenditList.startDate": {
            handler(val) {
                if (val) {
                    this.endNoTime = {
                        disabledDate(time) {
                            const time1 = new Date(val).getTime() - 8.64e7;
                            return time.getTime() < time1 || time.getTime() > Date.now()
                        }
                    }
                } else {
                    // 当清空时，进行一些默认的设置或恢复初始的禁用规则
                    this.endNoTime = {
                        disabledDate(time) {
                            return time.getTime() > Date.now()
                        }
                    }
                }
            }
        },
        "expenditList.endDate": {
            handler(val) {
                if (val) {
                    this.startNoTime = {
                        disabledDate(time) {
                            const time1 = new Date(val).getTime()
                            return time.getTime() > time1 || time.getTime() > Date.now()
                        }
                    }
                } else {
                    this.startNoTime = {
                        disabledDate(time) {
                            return time.getTime() > Date.now()
                        }
                    }
                }
            }
        },
        'form.company': function (newValue, oldValue) {
            // 往来单位发生变化时检查币制是否也有值，如果都有值则调用接口
            if (newValue && this.form.currency) {
                // this.form.bank ='';
                // this.fetchBankAccounts();
                if (JSON.stringify(newValue) !== JSON.stringify(oldValue) && newValue && oldValue) {
                    // this.form.allBank = '';
                    // this.form.bank = '';
                    // this.form.bankAccount = ''
                }

            }
        },
        'form.currency': function (newValue, oldValue) {
            // 币制发生变化时检查往来单位是否也有值，如果都有值则调用接口
            if (newValue && this.form.company) {
                // this.form.bank ='';
                // this.fetchBankAccounts();
                if (JSON.stringify(newValue) !== JSON.stringify(oldValue) && newValue && oldValue) {
                    // this.form.allBank = '';
                    // this.form.bank = '';
                    // this.form.bankAccount = ''
                }

            }
        },
        // 'form.amount': {
        //     handler(newVal, oldVal) {
        //         // 当 account 值发生变化时执行保存操作
        //         if (!this.isInitialLoad) {
        //             this.saveHeader(1);
        //         }               
        //     },
        //     deep: true,
        //     immediate: false 
        // }
    },
    computed: {
    },

    mounted() {
        //数据渲染完毕后再监听

        // this.$watch('form.amount', {
        //     handler(newVal, oldVal) {
        //         if (!this.isInitialLoad) {
        //         this.saveHeader(1);

        //     },
        //     deep: true,
        //     immediate: false
        // });

    },
    created() {
        this.getcustomList();
        this.getTypeOption();
        this.getFeeList();
        // this.expendRow();
        // this.getFundDetail();
    },
    methods: {
        // 刷新附件
        refreshHeader(){
            this.uploadFiles(this.headerId)
        },
        // 文件下载
        downloadFile(data){
            // let a = document.createElement("a"); // 创建a标签
            // a.style.display = "none";
            // a.href = data.annexUrl;
            // a.setAttribute( "download", data.annexName ); // 给a标签设置download属性值，为从接口中获取到的需要下载的文件地址
            // document.body.appendChild(a); // 将标签添加到页面
            // a.click();
            // document.body.removeChild(a);
            const params = {
                path: '/preview',
                query: {
                    annexUrl: data.annexUrl,
                    annexName: data.annexName,
                    id: data.id
                }
            }
            window.open(this.$router.resolve(params).href, '_blank') // 这个就是打开新链接的方式
        },
        // 查询上传附件
        uploadFiles(id){
            // getFileListByVoucherId
            let URL = `${url1.getFileListByVoucherId}/${id}`;
            req.get(URL).then(res => {
                if (res.data.code === 200) {
                    this.uploadFilesList = res.data.data
                }
            })
        },
        // saveamount(){
        //     this.saveHeader(1);
        // },
        handleSelectionChange(val) {
            this.detailSelect = val;
        },
        limitInput(row) {
            if (parseFloat(row.remain) > row.remainCopy) {
                this.$message.warning('输入值不能高于余额');
                row.remain = row.remainCopy;
                this.isbig = true;

            } else {
                this.isbig = false;
            }

        },
        // 合计行
        //指定列求和
        // 合计金额
        // 合计行 方法
        getSummaries(param) {
            const { columns, data } = param
            const sums = []
            columns.forEach((column, index) => {
                if (index === 0) {
                    sums[index] = '合计'
                    return
                }
                // 这里添加需要进行合计的列的名称
                const sumColArr = ['结算金额']
                if (sumColArr.includes(column.label)) {
                    const values = data.map((item) => Number(item[column.property]))
                    if (!values.every((value) => isNaN(value))) {
                        sums[index] = values.reduce((prev, curr) => {
                            const value = Number(curr)
                            if (!isNaN(value)) {
                                return prev + curr
                            } else {
                                return prev
                            }
                        }, 0)
                            .toFixed(2) // 固定两位小数
                        sums[index] += '' // 这里可以添加单位 如： sums[index] += '元'
                    } else {
                        sums[index] = ' '
                    }
                }
            })
            this.form.amount = sums[3];
            this.isInitialLoad = false;
            return sums
        },

        rowStyle() {
            return "text-align:center";
        },
        //删除明细
        deleteRowDetail(row) {
            const value = localStorage.getItem('name');
            if (row.createMan !== value) {
                this.$message({
                    type: 'error',
                    message: '非本人创建，无法删除!'
                });
            } else {
                let URL = `${url1.removeDetailsByIds}`;
                let obj = [];
                obj.push(row.id);
                req.post(URL, obj).then(res => {
                    if (res.data.code == 200) {
                        this.$message({
                            type: 'success',
                            message: '删除成功!'
                        });
                        // obj.map(item => {
                        this.getDetailexList(this.form.id)
                        // this.saveHeader(1);
                        // })
                    } else {
                        this.$message({
                            type: 'error',
                            message: res.data.message
                        });
                    }
                })
            }

        },
        // 获取明细
        getDetailexList(feeId) {
            let URL = `${url1.getVoucherList}/${feeId}`;
            req.get(URL).then(res => {
                if (res.data.code === 200) {
                    this.detailData = res.data.data.data;
                } else {
                    this.$message({
                        type: 'error',
                        message: res.data.message
                    });
                }
            })
        },
        // 获取应付信息
        expendRow() {
            this.expenditList.custName = this.form.company;
            this.expenditList.currency = this.form.currency;
            // 将提单号转化为数组
            if(this.expenditList.blNo){
                this.expenditList.blNos = this.expenditList.blNo.split('\n');

            }else{
                this.expenditList.blNos = [];
            }
            let URL = `${url1.getFeeByConditon}/`;
            req.post(URL, this.expenditList).then(res => {
                if (res.data.code === 200) {
                    this.detailtableData = res.data.data;
                    this.detailtableData.forEach(row => {
                        this.$set(row, 'editing', false);
                        // row.finance = row.remain;
                        row.remainCopy = row.remain;
                        row.note = '';
                    });
                } else {
                    this.$message({
                        type: 'error',
                        message: res.data.message
                    })
                }
            })
        },
        addRow() {
            this.detailtableData.forEach(row => {
                // row.editing = false;
                this.$set(row, 'editing', true);
            });

        },
        deleteRow(row) {
            // 删除行的逻辑
            const index = this.detailtableData.indexOf(row);
            if (index !== -1) {
                this.detailtableData.splice(index, 1);

            }
        },
        startEditing(row) {
            this.$set(row, 'editing', true);
        },
        // 确定保存
        allSaveList() {
            if (this.detailSelect.length == 0) {
                this.$message.warning('请选择内容！');
            } else {
                let hasEmptyValue = false;
                this.detailSelect.forEach(row => {
                    if (!row.remain) {
                        hasEmptyValue = true;
                        return false; // 提前退出循环
                    }
                });
                if (hasEmptyValue) {
                    this.$message.warning('请填写完整空白内容');
                } else {
                    let flag = false;
                    this.detailSelect.forEach(row => {
                        if (row.editing == true) {
                            this.$set(row, 'editing', false);
                        }

                    })
                    if (flag) {
                        this.$message({
                            type: 'warning',
                            message: '请先保存全部！'
                        })
                    } else {
                        let URL = `${url1.pushVoucherDetail}`;
                        let obj = [];
                        //如果是编辑  else新增
                        obj = this.detailSelect.map(item => {
                            return {
                                voucherId: this.form.id,
                                feeId: item.id,
                                amount: item.remain,
                                note: item.note,
                                blNo: item.blNo,
                                subNo: item.subNo,
                                currency: item.currency,
                                containerNo:item.containerNo,
                            };
                        });
                        let shouldContinue = true;
                        for (const item of this.detailSelect) {

                            if (item.remain <= 0) {
                                this.$message({
                                    type: 'error',

                                    message: '应付额度不能小于等于0!'
                                });
                                shouldContinue = false;
                                break;
                            } else {
                                this.$nextTick(() => {
                                    obj.map(item => {
                                        this.getDetailexList(item.voucherId);
                                    });
                                })

                                shouldContinue = true;
                                break;
                            }
                        }

                        if (shouldContinue) {
                            req.post(URL, obj).then(res => {
                                if (res.data.code === 200) {
                                    this.$message({
                                        type: 'success',
                                        message: '更改成功'
                                    });
                                    this.$nextTick(() => {
                                        obj.map(item => {
                                            this.getDetailexList(item.voucherId);
                                        });
                                        this.detailSelect = [];
                                        this.expendRow();
                                    })

                                } else {
                                    this.$message({
                                        type: 'error',
                                        message: res.data.message
                                    });
                                }
                            });
                        }
                    }


                    // this.detailtableData.map(item => {
                    //     if (this.isbig) {
                    //         this.$message({
                    //             type: 'error',
                    //             message: '应付金额不能大于余额！'
                    //         })

                    //     } else if (item.remain <= 0) {
                    //         this.$message({
                    //             type: 'error',
                    //             message: '应付额度不能小于等于0!'
                    //         })
                    //     } else {
                    //         obj.map(item => {
                    //             this.getDetailexList(item.voucherId)
                    //         })
                    //     }
                    // })
                    // req.post(URL, obj).then(res => {
                    //     if (res.data.code === 200) {
                    //         this.$message({
                    //             type: 'success',
                    //             message: '更改成功'
                    //         })
                    //         // this.expendRow();                                  
                    //         obj.map(item => {
                    //             this.getDetailexList(item.voucherId)
                    //         })
                    //         this.detailtableData = [];
                    //     } else {
                    //         this.$message({
                    //             type: 'error',
                    //             message: res.data.message
                    //         })
                    //     }
                    // })
                }
            }
        },
        save(row) {
            this.$set(row, 'editing', false);
        },
        saveAll() {
            this.detailtableData.forEach(row => {
                // row.editing = false;
                this.$set(row, 'editing', false);
            });
        },
        //费用名称
        getFeeList() {
            let URL = `${url.fee}?feeName=`;
            req.get(URL).then(res => {
                if (res.data.code === 200) {
                    this.feeOption = res.data.data;
                }
            })
        },
        // 初始化表头
        getFundDetail(row) {
            if( row === 0){
                this.editCode = true
                // this.form.checkStatus = 0
                this.form = {
                    checkStatus:0,
                    company: '',
                    voucherNo: '',
                    note: '',//备注
                    amount: '',
                    currency: '',
                    id: '',
                }
            }else{
                let URL = `${url1.getVoucherHeadById}/${this.busId}`;
                req.get(URL).then(res => {
                    res.data.data.amount = row.amount;
                    this.form = res.data.data;
                    this.headerId = res.data.data.id;
                    this.getDetailexList(this.headerId)
                    // let bank = this.form.bank;
                    // this.form.bank = `${this.form.bankAccount}-${bank}`;
                    for (let item of this.customOption) {
                        if (item.name === this.form.company) {
                            this.companyId = item.id;
                        }
                    }
                    this.bh = this.form.billNo;
                    this.expenditList.custName = this.form.company;
                    this.expenditList.currency = this.form.currency;
                    this.uploadFiles(this.headerId)
                    // this.fetchBankAccounts();
                })
            }
        },
        beforeclose() {
            this.$refs.form.resetFields()
            this.expenditList = {
                feeName: '',
                blNo: '',
                custName: '',
                currency: '',
                startDate: '',
                endDate: '',
                feeType: 1
            },
            this.detailData = [];
            this.detailtableData = [];
            this.form = {}
            this.form.allBank = '';
            this.form.id = '';
            this.form.company = '';
            this.form.voucherNo = '';
            // this.form.bank = '';
            // this.form.bankAccount = '';
            this.form.note = '';
            this.form.amount = '';
            this.form.currency = '';
            this.bh = '';
            this.headerId = '';
            this.dialogFormVisible = false;
            this.bankOption = [];
            this.uploadFilesList = []
            this.editCode = false;
            this.$parent.submit();
        },
        selectCompany(data) {
            const { value, label,invoiceInfo } = data;
            // 对formValue中的银行code和银行名称重新赋值
            this.form.company = label;
            this.companyId = value;
            this.form.invoiceInfo = invoiceInfo;
        },
        // selectBank(data) {
        //     const { value, label } = data;
        //     // 对formValue中的银行code和银行名称重新赋值
        //     // this.form.bank = value;
        //     this.form.bankAccount = label;
        //     this.form.bank = `${label}-${value}`;
        // },

        saveHeader(form) {
            // if (form === 1) {
            //     if (this.form.currency === '' || this.form.company === '' || this.form.voucherNo === '') {
            //         // this.$message({
            //         //     type: 'error',
            //         //     message: '请填写必填项'
            //         // });
            //         return;
            //     } else {
            //         let URL = `${url1.saveOrUpdateVoucherBase}`;
            //         // let bank = this.form.bank.split('-')[0];
            //         // this.form.bank = bank;
            //         this.form.flag = 'FP';
            //         let newForm = { ...this.form };

            //         // 删除新对象中的amount属性
            //         delete newForm.amount;
            //         if (!this.form.id) {
            //             req.post(URL, newForm).then(res => {
            //                 if (res.data.code === 200) {
            //                     this.$message({
            //                         type: 'success',
            //                         message: res.data.message
            //                     })
            //                     let option = res.data.data;
            //                     this.form.id = option.split("|")[0];
            //                     this.getDetailexList(option.split("|")[0])
            //                     this.bh = option.split("|")[1];
            //                 } else {
            //                     this.$message({
            //                         type: 'error',
            //                         message: res.data.message
            //                     })
            //                 }
            //             })
            //         } else {
            //             this.form.flag = 'FP';
            //             let newForm = { ...this.form };

            //             // 删除新对象中的amount属性
            //             delete newForm.amount;
            //             req.post(URL, newForm).then(res => {
            //                 if (res.data.code === 200) {
            //                     // this.$message({
            //                     //     type: 'success',
            //                     //     message: res.data.message
            //                     // })
            //                 } else {
            //                     this.$message({
            //                         type: 'error',
            //                         message: res.data.message
            //                     })
            //                 }
            //             })
            //         }
            //     }
            // } else {
                this.$refs[form].validate((valid) => {
                    if (valid) {         
                        let URL = `${url1.saveOrUpdateVoucherBase}`;
                        // let bank = this.form.bank.split('-')[0];
                        // this.form.bank = bank;
                        this.form.flag = 'FP';
                        // delete this.form.bank;
                        if (!this.form.id) {
                            let newForm = { ...this.form };
                            // 删除新对象中的amount属性
                            delete newForm.amount;
                            req.post(URL, newForm).then(res => {
                                if (res.data.code === 200) {
                                    this.$message({
                                        type: 'success',
                                        message: res.data.message
                                    })
                                    let option = res.data.data;
                                    this.form.id = option.split("|")[0];
                                    this.getDetailexList(option.split("|")[0])
                                    this.bh = option.split("|")[1];
                                    // 保存文件
                                    this.sureUpload(option.split('|')[0])
                                } else {
                                    this.$message({
                                        type: 'error',
                                        message: res.data.message
                                    })
                                }
                            })
                        } else {
                            this.form.flag = 'FP';
                            let newForm = { ...this.form };
                            // 删除新对象中的amount属性
                            delete newForm.amount;
                            req.post(URL, newForm).then(res => {
                                if (res.data.code === 200) {
                                    this.$message({
                                        type: 'success',
                                        message: res.data.message
                                    })
                                    // 保存文件
                                    this.sureUpload(this.form.id)
                                } else {
                                    this.$message({
                                        type: 'error',
                                        message: res.data.message
                                    })
                                }
                            })
                        }
                    } else {
                        this.$message({
                            type: 'error',
                            message: '请填写必填项'
                        });
                    }
                });
            // }
        },
        // 确认上传文件
        async sureUpload(voucherId){
            // 调用删除费用信息接口
            if(this.fileList.length){
                 try {
                    // 创建Promise数组
                    const promises = this.fileList.map(item => {
                        const formData = new FormData();
                        formData.append('file', item.raw);
                        formData.append('voucherId', voucherId);
                        let fileUrl = `${url1.saveOneAttachment}`
                        return this.saveOneAttachment(fileUrl, formData);
                    });
                    // 等待所有上传完成
                    await Promise.all(promises);
                    this.uploadFiles(this.form.id)
                    // 完成后操作
                    this.fileList = [];
                    // 查询上传文件
                } catch (error) {
                    this.$message.error('上传失败: ' + error.message);
                }
            }
        },
        //    调用上传文件接口
        saveOneAttachment(fileUrl,formData){
            return  req.post(fileUrl,formData).then(res => {
                if (res.data.code === 200) {
                    return res.data
                }else{
                    throw new Error(res.data.message || '上传失败');
                }
            })
        },
        //获取银行账号密码
        // fetchBankAccounts() {
        //     let URL = `${url1.getBankInfo}/${this.companyId}/${this.form.currency}`;
        //     req.get(URL).then(res => {
        //         if (res.data.code === 200) {
        //             this.bankOption = res.data.data;
        //             // this.form.bank = res.data.data.bank;
        //             // this.form.bankAccount = res.data.data.bankAccount;
        //         }
        //     })
        // },
        //获取委托单位数据
        getcustomList() {
            let URL = `${url1.getList}/?name=`;
            req.get(URL).then(res => {
                if (res.data.code === 200) {
                    this.customOption = res.data.data;
                }
            })
        },
        //获得币制数据
        getTypeOption() {
            let value = '币制';
            let URL = `${url.getDicList}/?value=${value}`;
            req.get(URL).then(res => {
                if (res.data.code === 200) {
                    this.typeOption = res.data.data.data;
                }
            })
        },
        // 文件上传时勾子
        handleChange(file, fileList){
            this.fileList = fileList;
        },
        // 移除文件勾子
        handleRemove(file, fileList){
            this.fileList = fileList;
        },
    },
}
</script>

<style lang="css" scoped>
::v-deep body,
html {
    overflow-y: hidden;
}

::v-deep .el-input__inner {
    height: 1.9em;
}

.el-select {
    width: 100%;
}

.el-form-item {
    margin-bottom: 0.6vh;
}


::v-deep .el-table .el-table__cell {
    padding: 1.1px 0;
}

::v-deep .el-dialog.is-fullscreen {
    background-color: #F8F8F5;
}
::v-deep .el-dialog {
    margin: 10px auto !important;
}
.el-form-item__error {
    padding-top: 0;
}

::v-deep .el-input.is-disabled .el-input__inner {
    background-color: #f4f5f7;
    color: #030303;
}
.upload_box{
    display: flex;
}
.upload_text{
    text-align: right;
    width: 80px;
    margin-right: 10px;
    margin-bottom: 10px;
}
.upload-list{
    min-width: 600px;
    display: flex;
}
.list-margin{
    margin: 0px 5px;
}
::v-deep  .el-form-item__content {
    width: 280px !important;
}
::v-deep .el-divider__text {
    color: #959595 ;
}
::v-deep .el-divider__text {
    color: #959595 ;
}
::v-deep .upload-demo{
    display: flex;
}
::v-deep .el-upload-list {
    display: flex;
}
::v-deep .el-upload-list__item:first-child {
    margin-top: 5px;
    margin-left: 10px;
}
::v-deep .el-dialog__body{
   padding: 10px; 
}
::v-deep .el-dialog__header {
    padding: 10px;
}
</style>